// source: wisetime/user/timelinemessage/v4/user_timeline_message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_type_date_pb = require('../../../../google/type/date_pb.js');
goog.object.extend(proto, google_type_date_pb);
goog.exportSymbol('proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest', null, global);
goog.exportSymbol('proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse', null, global);
goog.exportSymbol('proto.wisetime.user.timelinemessage.v4.UserTimelineMessage', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.displayName = 'proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse.displayName = 'proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.timelinemessage.v4.UserTimelineMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.timelinemessage.v4.UserTimelineMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.displayName = 'proto.wisetime.user.timelinemessage.v4.UserTimelineMessage';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    startDate: (f = msg.getStartDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    endDate: (f = msg.getEndDate()) && google_type_date_pb.Date.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest}
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest;
  return proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest}
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 3:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest} returns this
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.type.Date start_date = 2;
 * @return {?proto.google.type.Date}
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.prototype.getStartDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 2));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest} returns this
*/
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest} returns this
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.type.Date end_date = 3;
 * @return {?proto.google.type.Date}
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.prototype.getEndDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 3));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest} returns this
*/
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest} returns this
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesRequest.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    timelineMessagesList: jspb.Message.toObjectList(msg.getTimelineMessagesList(),
    proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse}
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse;
  return proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse}
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.timelinemessage.v4.UserTimelineMessage;
      reader.readMessage(value,proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.deserializeBinaryFromReader);
      msg.addTimelineMessages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimelineMessagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UserTimelineMessage timeline_messages = 1;
 * @return {!Array<!proto.wisetime.user.timelinemessage.v4.UserTimelineMessage>}
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse.prototype.getTimelineMessagesList = function() {
  return /** @type{!Array<!proto.wisetime.user.timelinemessage.v4.UserTimelineMessage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.timelinemessage.v4.UserTimelineMessage, 1));
};


/**
 * @param {!Array<!proto.wisetime.user.timelinemessage.v4.UserTimelineMessage>} value
 * @return {!proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse} returns this
*/
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse.prototype.setTimelineMessagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wisetime.user.timelinemessage.v4.UserTimelineMessage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.timelinemessage.v4.UserTimelineMessage}
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse.prototype.addTimelineMessages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wisetime.user.timelinemessage.v4.UserTimelineMessage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse} returns this
 */
proto.wisetime.user.timelinemessage.v4.ListUserTimelineMessagesResponse.prototype.clearTimelineMessagesList = function() {
  return this.setTimelineMessagesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.timelinemessage.v4.UserTimelineMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    siteId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    content: jspb.Message.getFieldWithDefault(msg, 3, ""),
    date: (f = msg.getDate()) && google_type_date_pb.Date.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.timelinemessage.v4.UserTimelineMessage}
 */
proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.timelinemessage.v4.UserTimelineMessage;
  return proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.timelinemessage.v4.UserTimelineMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.timelinemessage.v4.UserTimelineMessage}
 */
proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    case 4:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.timelinemessage.v4.UserTimelineMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timelinemessage.v4.UserTimelineMessage} returns this
 */
proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string site_id = 2;
 * @return {string}
 */
proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timelinemessage.v4.UserTimelineMessage} returns this
 */
proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string content = 3;
 * @return {string}
 */
proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.timelinemessage.v4.UserTimelineMessage} returns this
 */
proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.type.Date date = 4;
 * @return {?proto.google.type.Date}
 */
proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.prototype.getDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 4));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.wisetime.user.timelinemessage.v4.UserTimelineMessage} returns this
*/
proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.timelinemessage.v4.UserTimelineMessage} returns this
 */
proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.timelinemessage.v4.UserTimelineMessage.prototype.hasDate = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.wisetime.user.timelinemessage.v4);
